import { Dispatch } from "redux";
import { ActionType } from "../actions/ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface ClerkUserPayload {
  uid: string;
  email: string | undefined;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string;
}

// clerk authebtication
export const ClerkAuth = (payload: ClerkUserPayload) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.CLERK_AUTHENTICATION_INIT });
      const url = `${BASE_URL}/clerkAuth/sync-clerk-user`;

      const response = await axios.post(url, payload);

      dispatch({
        type: ActionType.CLERK_AUTHENTICATION_SUCCESS,
        payload: response.data,
      });
      return response;
    } catch (error: any) {
      toast.error(error.response?.data?.error_message);
      dispatch({
        type: ActionType.CLERK_AUTHENTICATION_FAIL,
        payload: error.response?.data?.error_message,
      });
    }
  };
};

export const SendOTPonEmail = (email: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.SEND_EMAIL_OTP_INIT });

      // Check if user exists
      const checkUserUrl = `${BASE_URL}/user/email?email=${encodeURIComponent(
        email
      )}`;
      const checkUserResponse = await axios.get(checkUserUrl);

      if (checkUserResponse.data?.length > 0 && checkUserResponse.data[0].verified) {
        toast.error("Email already is registered and verified, please log in");
        dispatch({
          type: ActionType.SEND_EMAIL_OTP_FAIL,
          payload: "Email already is registered and verified, please log in",
        });
        return;
      }

      // If user does not exist, send OTP
      const sendOtpUrl = `${BASE_URL}/authenticate/email-signup?email=${encodeURIComponent(
        email
      )}`;
      const sendOtpResponse = await axios.post(sendOtpUrl);

      dispatch({
        type: ActionType.SEND_EMAIL_OTP_SUCCESS,
        payload: sendOtpResponse.data,
      });

      toast.success("OTP has been sent to your email.");
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        "An unexpected error occurred. Please try again later.";

      if (error.response?.status === 502) {
        toast.error(
          "The server is temporarily unavailable. Please try again later."
        );
      } else {
        toast.error(errorMessage);
      }

      dispatch({
        type: ActionType.SEND_EMAIL_OTP_FAIL,
        payload: errorMessage,
      });
    }
  };
};

export const VerifyEmailOTP = (code: string) => {
  return async (dispatch: Dispatch<any>) => {
    const methodId = localStorage.getItem("methodId");

    if (methodId === "undefined" || methodId === "") {
      toast.error("Something went wrong!");
    }

    if (methodId !== "undefined" && methodId !== "") {
      try {
        dispatch({ type: ActionType.VERIFY_EMAIL_OTP_INIT });
        const url = `${BASE_URL}/authenticate/email-verify?code=${encodeURIComponent(
          code
        )}`;

        const data = {
          methodId: methodId,
        };
        const response = await axios.post(url, data);

        localStorage.setItem(
          "sessionToken",
          response?.data?.data.session_token
        );
        localStorage.setItem("user_id", response?.data?.data.user_id);
        dispatch({
          type: ActionType.VERIFY_EMAIL_OTP_SUCCESS,
          payload: response.data,
        });
      } catch (error: any) {
        if (error.response.status === 500) {
          toast.error("Error verifying OTP");
          dispatch({
            type: ActionType.SEND_EMAIL_OTP_FAIL,
            payload: "Error verifying OTP",
          });
        }
        toast.error(error.response?.data?.message);
        dispatch({
          type: ActionType.VERIFY_EMAIL_OTP_FAIL,
          payload: error.response?.data?.message,
        });
      }
    } else {
      toast.error("Something went wrong!");
      dispatch({
        type: ActionType.VERIFY_EMAIL_OTP_FAIL,
        payload: "Something went wrong!",
      });
    }
  };
};

export const SetUserDetailsForEmail = (userData: object) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.PUT_DETAILS_EMAIL_INIT });
      const url = `${BASE_URL}/authenticate/email-password-session`;
      const response = await axios.post(url, userData);
      dispatch({
        type: ActionType.PUT_DETAILS_EMAIL_SUCCESS,
        payload: response.data,
      });
      if (response.status === 201) {
        toast.success("Account created successfully");
      }
    } catch (error: any) {
      if (error.response?.data.error_type === "breached_password") {
        toast.error(
          "This password has been breached. Please choose a different one."
        );
        dispatch({
          type: ActionType.PUT_DETAILS_EMAIL_FAIL,
          payload:
            "This password has been breached. Please choose a different one.",
        });
      } else {
        toast.error("Please try again leter");
        dispatch({
          type: ActionType.PUT_DETAILS_EMAIL_FAIL,
          payload: "Please try again leter",
        });
      }
    }
  };
};
export const SendOTPonPhonenumber = (phonenumber: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.SEND_PHONE_OTP_INIT });

      const url = `${BASE_URL}/authenticate/phone-login?phone=${encodeURIComponent(phonenumber)}`;
      const response = await axios.post(url);

      if (response.data?.message) {
        localStorage.setItem("user_created", response.data.otp?.user_created ?? "false");
        localStorage.setItem("methodId", response.data.otp?.phone_id ?? "");
      } else {
        localStorage.setItem("user_created", response.data?.user_created ?? "false");
        localStorage.setItem("methodId", response.data?.phone_id ?? "");
      }

      dispatch({
        type: ActionType.SEND_PHONE_OTP_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      console.error("OTP Request Error:", error);

      let errorMessage = "Something went wrong. Please try again later.";

      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = error.response.data?.error || "Invalid phone number. Please check and try again.";
            break;
          case 502:
            errorMessage = "Unable to send OTP. Please try again later.";
            break;
          case 500:
            errorMessage = "Server error. Please try again later.";
            break;
          default:
            errorMessage = error.response.data?.error || errorMessage;
            break;
        }
      }

      toast.error(errorMessage);
      dispatch({
        type: ActionType.SEND_PHONE_OTP_FAIL,
        payload: errorMessage,
      });
    }
  };
};


export const VerifyPhoneOTP = (code: string) => {
  return async (dispatch: Dispatch<any>) => {
    const methodId = localStorage.getItem("methodId");

    if (methodId === "undefined" || methodId === "") {
      toast.error("Something went wrong!");
    }

    if (methodId !== "undefined" && methodId !== "") {
      try {
        dispatch({ type: ActionType.VERIFY_PHONE_OTP_INIT });
        const url = `${BASE_URL}/authenticate/phone-verify?code=${encodeURIComponent(
          code
        )}`;

        const data = {
          methodId: methodId,
        };
        const response = await axios.post(url, data);

        if (
          response?.data?.status_code === 200 &&
          localStorage.getItem("user_created") === "false"
        ) {
          localStorage.setItem("uid", response?.data?.user_id);
        }

        dispatch({
          type: ActionType.VERIFY_PHONE_OTP_SUCCESS,
          payload: response.data,
        });
      } catch (error: any) {
        toast.error(
          "The passcode was incorrect and could not be authenticated"
        );
        dispatch({
          type: ActionType.VERIFY_PHONE_OTP_FAIL,
          payload: error.response?.data?.error_message,
        });
      }
    } else {
      toast.error("Something went wrong!");
      dispatch({
        type: ActionType.VERIFY_PHONE_OTP_FAIL,
        payload: "Something went wrong!",
      });
    }
  };
};

export const SetUserDetailsForPhone = (userData: object) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.PUT_DETAILS_PHONE_INIT });
      const url = `${BASE_URL}/authenticate/phone-migrate`;
      const response = await axios.put(url, userData);
      dispatch({
        type: ActionType.PUT_DETAILS_PHONE_SUCCESS,
        payload: response.data,
      });
      if (response.status === 200) {
        localStorage.setItem("uid", response?.data?.uid);
      } else {
        toast.error("Unexpected error occured");
        dispatch({
          type: ActionType.PUT_DETAILS_PHONE_FAIL,
          payload: "Unexpected error occured",
        });
      }
    } catch (error: any) {
      toast.error("Please try again leter");
      dispatch({
        type: ActionType.PUT_DETAILS_PHONE_FAIL,
        payload: "Please try again leter",
      });
    }
  };
};

export const EmailLogin = (email: string, password: string) => {
  return async (dispatch: Dispatch<any>) => {
    const data = {
      email: email,
      password: password,
    };
    try {
      dispatch({ type: ActionType.LOGIN_WITH_EMAIL_INIT });
      const url = `${BASE_URL}/authenticate/email-password-authenticate`;

      const response = await axios.post(url, data);

      dispatch({
        type: ActionType.LOGIN_WITH_EMAIL_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      toast.error(error.response?.data?.error_message);
      dispatch({
        type: ActionType.LOGIN_WITH_EMAIL_FAIL,
        payload: error.response?.data?.error_message,
      });
    }
  };
};

export const userLogout = () => {
  return async (dispatch: Dispatch<any>) => {
    dispatch({
      type: ActionType.USER_LOGOUT,
    });
    localStorage.clear();
  };
};

// This will kick off an email sent to the user to reset their password.
// Email will contain link to either reset password or login without password.
// Logging in without password will have this example: http://localhost:3000/authenticate?stytch_token_type=login&token=FfHFe4N72LvrM5Y7ioUJRoh1hylkYGj-GfDDVMcxumvp
// Resetting password will have this link: http://localhost:3000/authenticate?stytch_token_type=reset_password&token=2bbyGW6Btq5ieiYLfjclyOTbFEcOfPiOUnZoxGcUFrOa
export const resetPasswordSend = (email: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.RESET_PASSWORD_SEND_INIT });
      const url = `${BASE_URL}/authenticate/reset-password-start`;
      const data = {
        email: email,
      };
      const response = await axios.post(url, data);
      dispatch({
        type: ActionType.RESET_PASSWORD_SEND_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      toast.error("An unexpected error occurred");
      dispatch({
        type: ActionType.RESET_PASSWORD_SEND_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};

export const resetPasswordConfirm = (token: string, password: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.RESET_PASSWORD_INIT });
      const url = `${BASE_URL}/authenticate/reset-password-confirm`;
      const data = {
        password: password,
        token: token,
      };
      const response = await axios.post(url, data);
      dispatch({
        type: ActionType.RESET_PASSWORD_SUCCESS,
        payload: response.data,
      });
      if (response.status === 200) {
        toast.success("Password reset successfully");
      }
    } catch (error: any) {
      toast.error("Reset link is expired or invalid");
      dispatch({
        type: ActionType.RESET_PASSWORD_FAIL,
        payload: error.response.data.error_message || "An unexpected error occurred",
      });
    }
  };
};
